import React from 'react';
import {
  TextField as MuiTextField,
  Select as MuiSelect,
  styled,
  TextFieldProps,
  SelectProps,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export const TPTextField = styled(MuiTextField)({
  '& label': {
    color: '#000000',
  },
  '& label.Mui-focused': {
    color: '#000000',
  },
  '& input': {
    color: '#000000',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#CBD5E1',
    },
    '&:hover fieldset': {
      borderColor: '#B2BAC2',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#B2BAC2',
    },
  },
});

export const TPSelect = styled(MuiSelect)({
  '& label': {
    color: '#000000',
  },
  '& label.Mui-focused': {
    color: '#000000',
  },
  '& input': {
    color: '#000000',
  },
  '& .MuiSelect-select': {
    color: '#000000',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#CBD5E1',
    },
    '&:hover fieldset': {
      borderColor: '#B2BAC2',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#B2BAC2',
    },
  },
  // Additional focus styles for better specificity
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#B2BAC2',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#B2BAC2',
  },
});

export const TPAutoCompleteArrowIconComponent = (
  <KeyboardArrowDownIcon
    fontSize="small"
    style={{
      backgroundColor: '#E2E8F0',
      color: '#1E293B',
      borderRadius: '4px',
    }}
  />
);

export const defaultTextFieldProps: TextFieldProps = {
  sx: {
    backgroundColor: '#ffffff',
    '& .MuiInputBase-root': {
      height: '52px',
    },
  },
  InputLabelProps: {
    shrink: true,
  },
};

export const defaultSelectProps: SelectProps = {
  sx: {
    backgroundColor: '#ffffff',
    '& .MuiInputBase-root': {
      height: '52px',
    },
    // Ensure focus styles are applied
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#B2BAC2',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#B2BAC2',
    },
  },
};
